export const data4 = [
    {
      "name": "CPU1",
      "value": 8900
    },
    {
      "name": "CPU2",
      "value": 5000
    },
    {
      "name": "CPU3",
      "value": 7000
    },
    {
      "name": "CPU4",
      "value": 1000
    },
];

export const data3 = [
    {
        "name": "connected",
        "value": 200
    },
    {
        "name": "disconnected",
        "value": 100
    },
    {
        "name": "polling",
        "value": 50
    }
];

export const data2 = [
    {
      "name": "usage",
      "value": 60
    },
    {
      "name": "total scenes",
      "value": 150
    },
];

export const data6 = [
    {
        "name": "vidoes",
        "value": 60
    },
    {
        "name": "images",
        "value": 150
    },
    {
        "name": "paints",
        "value": 110
    },
    {
        "name": "scenes",
        "value": 70
    },
    {
        "name": "resources",
        "value": 90
    },
    {
        "name": "other files",
        "value": 80
    },
];

export const data100 = [
    {
        "name": "name1",
        "series": [
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-13T12:43:48.855Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-20T13:38:53.324Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-21T00:00:34.015Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-19T15:17:13.134Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-22T03:26:39.889Z")
            },
            {
                "name": new Date("2016-09-18T01:27:13.798Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-15T19:18:35.786Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T06:27:24.739Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:26:04.627Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:41:42.307Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T13:03:21.062Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T19:25:42.622Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T00:06:45.533Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T17:53:05.641Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T19:57:02.380Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T04:17:35.009Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:43:58.442Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T18:32:04.175Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T21:03:39.258Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:40:31.764Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-25T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-23T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-24T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
        ]
    },
    {
        "name": "name2",
        "series": [
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-13T12:43:48.855Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-20T13:38:53.324Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-21T00:00:34.015Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-19T15:17:13.134Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-22T03:26:39.889Z")
            },
            {
                "name": new Date("2016-09-18T01:27:13.798Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-15T19:18:35.786Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T06:27:24.739Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:26:04.627Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:41:42.307Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T13:03:21.062Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T19:25:42.622Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T00:06:45.533Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T17:53:05.641Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T19:57:02.380Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T04:17:35.009Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:43:58.442Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T18:32:04.175Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T21:03:39.258Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:40:31.764Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-25T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-23T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-24T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
        ]
    },
    {
        "name": "name3",
        "series": [
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-13T12:43:48.855Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-20T13:38:53.324Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-21T00:00:34.015Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-19T15:17:13.134Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-22T03:26:39.889Z")
            },
            {
                "name": new Date("2016-09-18T01:27:13.798Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-15T19:18:35.786Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T06:27:24.739Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:26:04.627Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:41:42.307Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T13:03:21.062Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T19:25:42.622Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T00:06:45.533Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T17:53:05.641Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T19:57:02.380Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T04:17:35.009Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:43:58.442Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T18:32:04.175Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T21:03:39.258Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:40:31.764Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-25T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-23T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-24T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
        ]
    },
    {
        "name": "name4",
        "series": [
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-13T12:43:48.855Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-20T13:38:53.324Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-21T00:00:34.015Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-19T15:17:13.134Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-22T03:26:39.889Z")
            },
            {
                "name": new Date("2016-09-18T01:27:13.798Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-15T19:18:35.786Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T06:27:24.739Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:26:04.627Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:41:42.307Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T13:03:21.062Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T19:25:42.622Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T00:06:45.533Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T17:53:05.641Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T19:57:02.380Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T04:17:35.009Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:43:58.442Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T18:32:04.175Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T21:03:39.258Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:40:31.764Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-25T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-23T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-24T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
        ]
    },
    {
        "name": "name5",
        "series": [
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-13T12:43:48.855Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-20T13:38:53.324Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-21T00:00:34.015Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-19T15:17:13.134Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-22T03:26:39.889Z")
            },
            {
                "name": new Date("2016-09-18T01:27:13.798Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-15T19:18:35.786Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T06:27:24.739Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:26:04.627Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:41:42.307Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T13:03:21.062Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T19:25:42.622Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T00:06:45.533Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T17:53:05.641Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T19:57:02.380Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T04:17:35.009Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:43:58.442Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T18:32:04.175Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T21:03:39.258Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:40:31.764Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-25T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-23T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-24T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
        ]
    },
    {
        "name": "name6",
        "series": [
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-13T12:43:48.855Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-20T13:38:53.324Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-21T00:00:34.015Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-19T15:17:13.134Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-22T03:26:39.889Z")
            },
            {
                "name": new Date("2016-09-18T01:27:13.798Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-15T19:18:35.786Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T06:27:24.739Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:26:04.627Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:41:42.307Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T13:03:21.062Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T19:25:42.622Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T00:06:45.533Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T17:53:05.641Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T19:57:02.380Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T04:17:35.009Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:43:58.442Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T18:32:04.175Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T21:03:39.258Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:40:31.764Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-25T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-23T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-24T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
        ]
    },
    {
        "name": "name7",
        "series": [
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-13T12:43:48.855Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-20T13:38:53.324Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-21T00:00:34.015Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-19T15:17:13.134Z")
            },
            {
                "value": Math.round(2000 * Math.random()),
                "name": new Date("2016-09-22T03:26:39.889Z")
            },
            {
                "name": new Date("2016-09-18T01:27:13.798Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-15T19:18:35.786Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T06:27:24.739Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:26:04.627Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T14:41:42.307Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-19T13:03:21.062Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T19:25:42.622Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T00:06:45.533Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-16T17:53:05.641Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-14T19:57:02.380Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T04:17:35.009Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:43:58.442Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T18:32:04.175Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T21:03:39.258Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-13T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-17T14:40:31.764Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-25T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-20T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-23T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
            {
                "name": new Date("2016-09-24T13:13:02.234Z"),
                "value": Math.round(2000 * Math.random())
            },
        ]
    }
];

export const data5 = [
    {
      "name": "vidoes",
      "value": 60
    },
    {
      "name": "images",
      "value": 150
    },
    {
      "name": "other files",
      "value": 80
    },
    {
        "name": "resource",
        "value": 40
    },
    {
        "name": "painter",
        "value": 100
    },
];

export const data10 = [
    {
        "name": "Oct 2020",
        "series": [
            {
                "name": "week1",
                "value": 50
            },
            {
                "name": "week2",
                "value": 30
            },
            {
                "name": "week3",
                "value": 70
            },
            {
                "name": "week4",
                "value": 25
            }
        ]
    },
    {
        "name": "Nov 2020",
        "series": [
            {
                "name": "week1",
                "value": 10
            },
            {
                "name": "week2",
                "value": 20
            },
            {
                "name": "week3",
                "value": 30
            },
            {
                "name": "week4",
                "value": 25
            }
        ]
    },

    {
        "name": "Dec 2020",
        "series": [
            {
                "name": "week1",
                "value": 15
            },
            {
                "name": "week2",
                "value": 35
            },
            {
                "name": "week3",
                "value": 50
            },
            {
                "name": "week4",
                "value": 30
            }
        ]
    },
];
